import '../../common/EsCommon.css';

import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../parent/EsAuth';
import { VIEW_LOGIN, VIEW_REGISTER } from '../../common/EsConstants';
import { FREE_REASONS, useEsSubMe } from '../../common/EsSubs';
import EsAccountSub, { EsSubPay } from '../account/EsAccountSub';
import EsSubFinances from './EsSubFinances';
import { useEsStrings } from '../../common/EsStrings';
import EsMinis from '../../common/EsMinis';

/**
 * Why subscribe, then the reader's own subscription: the pitch and the meters first, as
 * marketing, and under them the account's Subscription tab itself.
 */
export default function EsSubscribe() {
    const t = useEsStrings();
    const auth = useAuth();
    const { me } = useEsSubMe( auth.authenticated );
    // Carried to Register and Login, so a sign-in from here comes back here rather
    // than to the welcome page (Tim, 2026-10-11); esLoginDestination reads it.
    const location = useLocation();

    return (
        <section data-testid="es-subscribe-page" className="relative z-10 pb-4 pt-nav-room">
            <EsMinis />
            <div className="container">
                <div className="mx-auto max-w-[640px] px-4">
                    <h1 className="mb-8 text-2xl font-bold text-heading sm:text-3xl" data-testid="es-subscribe-heading">
                        { /* Donate for a lifetime account (admin, alpha, beta), as the nav bar says
                             (Tim, 2026-10-11); Subscribe for everyone else. */ }
                        { FREE_REASONS.includes( me?.reason )
                            ? t( 'subscribe-donate-title', 'Donate' )
                            : t( 'subscribe-title', 'Subscribe' ) }
                    </h1>

                    <div data-testid="es-subscribe-pitch">
                        <h2 className="mb-4 text-xl font-bold text-heading">
                            { t( 'subscribe-keeps-running', 'Escapade is independent. Subscribers keep it running.' ) }
                        </h2>
                        { /* mb-8 everywhere a block ends on this page: the heading's own gap
                             (Tim, 2026-10-11: "use the space between subscribe and next line"). */ }
                        <ul className="mb-8 list-disc pl-5 space-y-2">
                            <li>{ t( 'subscribe-point-campaigns', 'Create campaigns and run sessions for your table.' ) }</li>
                            <li>{ t( 'subscribe-point-homebrew', 'Create homebrew content and publish packs for others to use.' ) }</li>
                            <li>{ t( 'subscribe-point-players', 'Your players are always free. They join with a code and never pay.' ) }</li>
                            <li>{ t( 'subscribe-point-hosting-features', 'Your subscription pays for hosting and for new features yet to come.' ) }</li>
                        </ul>
                    </div>

                    { /* The pay button right after the bullets (Tim, 2026-10-11), the price
                         in its label. Never gated on the reader's status: a trial, a
                         subscriber, and a lifetime account all read the pitch and may pay,
                         and a payment extends whatever end they hold. An auto-renewing
                         account is not offered a second payment; its block is below. */ }
                    { auth.authenticated && me && !me.autoRenew && <EsSubPay me={ me } subscribe /> }
                    { /* The page is public; the paying is an account's. */ }
                    { !auth.authenticated && !auth.loading &&
                        <h2 className="mb-8 text-xl font-bold text-heading" data-testid="es-subscribe-sign-in">
                            { t( 'subscribe-sign-in-line', '{register} or {login} to subscribe.', {
                                register: <Link to={ VIEW_REGISTER } state={{ from: location }} data-testid="es-subscribe-register-link" className="text-accent hover:underline">
                                    { t( 'subscribe-register', 'Register' ) }
                                </Link>,
                                login: <Link to={ VIEW_LOGIN } state={{ from: location }} data-testid="es-subscribe-login-link" className="text-accent hover:underline">
                                    { t( 'subscribe-login', 'log in' ) }
                                </Link> } ) }
                        </h2> }

                    <EsSubFinances />

                    { auth.authenticated &&
                        <div className="mt-12" data-testid="es-subscribe-yours">
                            <h2 className="mb-4 text-xl font-bold text-heading">
                                { t( 'subscribe-yours', 'Your subscription' ) }
                            </h2>
                            <EsAccountSub pay={ false } />
                        </div> }
                </div>
            </div>
        </section>
    );
}
